export const BASE_URL = process.env.REACT_APP_API_URL ?? '';
export const BLOB_URL = process.env.REACT_APP_BLOB;
export const OCTA_AUTH_URL = process.env.REACT_APP_OCTA_AUTH_URL ?? '';
export const OCTA_LOGOUT_URL = process.env.REACT_APP_OCTA_LOGOUT_URL ?? '';
